<template>
  <div v-if="dadosFichaTecnica.tarefas_bloco && dadosFichaTecnica.tarefas_bloco.length > 0" class="grid">
    <div class="grid-row">
      <div class="titulo-grid"  v-b-toggle.collapse-3>
        Informações de Bloco: Nº {{ dadosFichaTecnica.tarefas_bloco[0].ctrl_bloco_id}}

        <SGPFormBotaoComponent @click="desfazerBlocoInteiro" class="mr-5 ml-5 mt-1 mb-1" small>
          <SGPIconComponent icon="mdi-trash-can-outline" class="mr-2" small />
          Desfazer Bloco
        </SGPFormBotaoComponent>

        <SGPIconComponent
          icon="mdi-chevron-down-circle"
          class="when-closed float-right mt-2"
          color="#444444"
        />
       
        <SGPIconComponent
          icon="mdi-chevron-up-circle"
          class="when-open float-right mt-2"
          color="#444444"
        />

      </div>
    </div>

    <template>
      <b-collapse id="collapse-3" class="mt-1" visible>
        <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">ID Tarefa</th>
                <th scope="col">Código Cir</th>
                <th scope="col">Serviço</th>
                <th scope="col">Tarefa</th>
                <th scope="col">Status</th>
                <th scope="col">Data Início Tarefa</th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dadosFichaTecnica.tarefas_bloco"
                  :key="index">
                <td> {{ item.pco_tarefa_id }}</td>
                <td> {{ item.cod_cir }}/{{ item.ponta.toUpperCase() }}</td>

                <td> {{ item.servico.toUpperCase() }}</td>
                <td> {{ item.tarefa }}</td>
                <td> {{ item.status_tarefa }} </td>
                <td> {{ formataDataBr(item.created_at) }} </td>
                <td class="text-center">  
                    <SGPFormBotaoComponent
                      v-if="!item.finalized_at"
                      fab
                      @click="excluirItem(item.pco_tarefa_id)"
                      color="primary"
                      x-small
                    >
                      <SGPIconComponent
                        icon="mdi-trash-can-outline"
                        color="white"
                      />
                    </SGPFormBotaoComponent>
                </td>
                <td class="text-center">
                  <a :href="getLinkFichaTecnica(item.pco_tarefa_id)">
                    <SGPFormBotaoComponent
                      fab
                      color="orange"
                      x-small
                    >
                      <SGPIconComponent
                        icon="mdi-open-in-new"
                        color="second"
                      />
                    </SGPFormBotaoComponent>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
      </b-collapse>
    </template>
    <div>
      <SGPConfirmacaoDelecaoComponent
          v-if="abrirModalDesagruparDados"
          @sgpCancelarDelecaoEmit="cancelarDesagrupar()"
          @sgpConfirmarDelecaoEmit="confirmarDesagrupar()"
          titulo="Atenção:"
          subtitulo="Tem certeza que deseja retirar o circuito do tratamento em bloco?"
      />
    </div>
    <div>
      <SGPConfirmacaoDelecaoComponent
          v-if="abrirModalDesfazerBlocoInteiro"
          @sgpCancelarDelecaoEmit="cancelarDesfazerBloco()"
          @sgpConfirmarDelecaoEmit="confirmarDesfazerBloco()"
          titulo="Atenção:"
          subtitulo="Tem certeza que deseja desfazer o bloco inteiro?"
      />
    </div>
 </div>  
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { formataDataBr } from '@/common/boot/Utils'

export default {
  name: "InformacoesBlocoComponent",
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    }
  },

  data (){
    return {
        abrirModalDesagruparDados:false,
        itensDesagrupar: [],
        abrirModalDesfazerBlocoInteiro:false,
    } 
  },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', ['loadingFichaTecnica','dadosFichaTecnica']),
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', ['desagruparTarefasBloco', 'desfazerBloco','buscarDadosFichaTecnica']),

    getLinkFichaTecnica(item) {
      var link = '';

      link = process.env.VUE_APP_FICHA_TECNICA_URL // '/sgp/nova-ficha-tecnica/'
      link += item
      
      return link == '' ? '#' : link;
    },

    excluirItem (item) {
      this.abrirModalDesagruparDados = true
      this.itensDesagrupar = [ item ]
    },

    cancelarDesagrupar() {
      this.abrirModalDesagruparDados = false
    },

    confirmarDesagrupar() {
      this.desagruparTarefasBloco({
          array_pco_tarefas_ids:this.itensDesagrupar, 
          agrupavel:0, 
          pco_tarefa_id:this.dadosFichaTecnica.pco_tarefa_id
      })
    },

    desfazerBlocoInteiro () {
      this.abrirModalDesfazerBlocoInteiro = true;
    },

    confirmarDesfazerBloco() {
      this.desfazerBloco({id:this.dadosFichaTecnica.tarefas_bloco[0].ctrl_bloco_id});
      this.buscarDadosFichaTecnica(this.$route.params.pco_tarefa_id); 
    },

    cancelarDesfazerBloco() {
      this.abrirModalDesfazerBlocoInteiro = false
    },

    formataDataBr,
  }
}
</script>